// extracted by mini-css-extract-plugin
export default {"fill":"IFButton_fill__iVaZk","filled":"IFButton_filled__GQSj5","disabled":"IFButton_disabled__J4UHx","FontIcon":"IFButton_FontIcon__G-LtK"};